import { isServer } from 'tradera/utils/nextjs';

const config =
    !isServer && window.sellingGlobalConfig
        ? { ...window.sellingGlobalConfig }
        : {};

config.maxTemplates = 100;
config.domainNameCategoryId = 344477;

export default config;
